export default {
  channel: 'Канал {{count}}',
};
